module.exports = {
    "removeButtonLabel": `Odstrani`,
    "removeDescription": `Pritisnite Delete, da odstranite oznako.`
};


//# sourceMappingURL=sl-SI.main.js.map
